/**
 * Invoice Mail Draft — field-level effects.
 *
 * Migrated from: manage/invoice-mail-draft.coffee
 *
 * Old transforms → new effects:
 *   ChangeStatus → ChangeStatus
 *
 * Skipped:
 *   handle(dfd) init logic — no runtime init needed
 */
import type { FieldHandler } from "@neu/libui";

// ─── ChangeStatus ──────────────────────────────────────────────────────────
// Old: DSLFx.Transforms.ChangeStatus
// Trigger field: is_draft_confirmed
// Updates the status field based on the draft confirmation selection.
export const ChangeStatus: FieldHandler = (field, { form }) => {
	const isDraftConfirmed = field.value;
	const status = form.getFieldState("status")?.value;

	if (isDraftConfirmed === "Schedule for Later" && status !== "Scheduled") {
		form.setFieldState("status", (s) => {
			s.value = "Scheduled";
		});
	} else if (isDraftConfirmed === "Yes" && status !== "Sent") {
		form.setFieldState("status", (s) => {
			s.value = "Pending";
		});
	}
	return "";
};
